// extracted by mini-css-extract-plugin
export var activeDot = "_37-c";
export var buttonContainer = "_37-9";
export var channelButton = "_37-a";
export var clickable = "_37-d";
export var content = "_37-0";
export var contentFull = "_37-2";
export var contentThird = "_37-1";
export var contentWrapper = "_37-7";
export var description = "_37-5";
export var heightShort = "_37-f";
export var image = "_37-3";
export var imageContainer = "_37-4";
export var selectButton = "_37-e";
export var spinnerContainer = "_37-b";
export var titleContent = "_37-8";
export var titleWrapper = "_37-6";